var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-input',_vm._b({attrs:{"color":"primary","mask":"######","type":"number"},on:{"input":_vm.handleInput}},'q-input',_vm.baseInputProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }